import { render, staticRenderFns } from "./ProgramList.vue?vue&type=template&id=72210be6&scoped=true"
import script from "./ProgramList.vue?vue&type=script&lang=js"
export * from "./ProgramList.vue?vue&type=script&lang=js"
import style0 from "./ProgramList.vue?vue&type=style&index=0&id=72210be6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72210be6",
  null
  
)

export default component.exports